import React from "react";
import { Link } from "react-router-dom";
import { MessageSquare, Phone } from "lucide-react";
import { business } from "../data/siteData";

export default function CtaBand({
  headline = "Ready for a free estimate?",
  copy = "Text a picture of your tub, tile or countertop and Ernest will get back to you — usually within one business day.",
}) {
  return (
    <section className="bg-[#244aa2]">
      <div className="mr-container flex flex-col items-center gap-6 py-14 text-center">
        <h2 className="font-head reveal max-w-2xl text-2xl font-extrabold text-white sm:text-3xl">
          {headline}
        </h2>
        <p className="reveal max-w-2xl text-white/85">{copy}</p>
        <div className="reveal flex flex-col gap-3 sm:flex-row">
          <Link
            to="/contact-us"
            className="bg-white px-8 py-3.5 text-[13px] font-bold uppercase tracking-[0.1em] text-[#244aa2] transition-transform duration-200 hover:-translate-y-0.5 hover:bg-[#e8eefb]"
          >
            Contact Us
          </Link>
          <a
            href={`tel:${business.phoneRaw}`}
            className="flex items-center justify-center gap-2 border-2 border-white px-8 py-3.5 text-[13px] font-bold uppercase tracking-[0.1em] text-white transition-colors duration-200 hover:bg-white hover:text-[#244aa2]"
          >
            <Phone className="h-4 w-4" /> {business.phone}
          </a>
          <a
            href={`sms:1${business.phoneDigits}`}
            className="flex items-center justify-center gap-2 bg-[#a10000] px-8 py-3.5 text-[13px] font-bold uppercase tracking-[0.1em] text-white transition-colors duration-200 hover:bg-[#7d0000]"
          >
            <MessageSquare className="h-4 w-4" /> Text Photos
          </a>
        </div>
      </div>
    </section>
  );
}
